import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "pp-ticket-check-results-detail" }
const _hoisted_2 = { class: "bs-container" }
const _hoisted_3 = { class: "c-12 bs-offset-md-1 c-md-10" }
const _hoisted_4 = { class: "pp-ticket-check-results-detail__heading" }

import { computed } from "vue";
import { usePpTicketCheck } from "../../composables/use-ticket-check";
import PpTicketCheckResultsMainGameTable from "./pp-ticket-check-results-main-game-table.vue";
import { LotteryParser } from "@sazka/lotteries/js/utils/lottery-parser";
import PpTicketCheckResultsAddonTable from "./pp-ticket-check-results-addon-table.vue";
import { usePpWagerConfiguration } from "../../composables/use-wager-configuration";
import PpTicketCheckResultsDrawDetail from "./pp-ticket-check-results-draw-detail.vue";
import PpTicketCheckResultsRychla6Table from "./pp-ticket-check-results-rychla-6-table.vue";
import PpTicketCheckResultsStastneDatumTable from "./pp-ticket-check-results-stastne-datum-table.vue";
import { Lottery } from "@sazka/lotteries/js/models/lottery";


export default /*@__PURE__*/_defineComponent({
  __name: 'pp-ticket-check-results-detail',
  setup(__props) {

const { ticketCheckResult } = usePpTicketCheck();

const { config } = usePpWagerConfiguration();
const isAddonPlayed = !!ticketCheckResult.value.drawsResults[0].addon;
const lotteryAddonDisplayName = computed(() => LotteryParser.addonDisplayName(config.lottery));

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(ticketCheckResult).drawsResults, (drawResults) => {
        return (_openBlock(), _createElementBlock("div", {
          key: drawResults.drawId,
          class: "bs-row"
        }, [
          _createElementVNode("div", _hoisted_3, [
            _cache[1] || (_cache[1] = _createElementVNode("h3", { class: "pp-ticket-check-results-detail__heading" }, "Vaše uhodnutá čísla", -1)),
            (_unref(config).lottery === _unref(Lottery).rychla6)
              ? (_openBlock(), _createBlock(PpTicketCheckResultsRychla6Table, {
                  key: 0,
                  lottery: _unref(Lottery).rychla6,
                  results: drawResults.boards
                }, null, 8, ["lottery", "results"]))
              : (_unref(config).lottery === _unref(Lottery).stastneDatum)
                ? (_openBlock(), _createBlock(PpTicketCheckResultsStastneDatumTable, {
                    key: 1,
                    results: drawResults.boards
                  }, null, 8, ["results"]))
                : (_openBlock(), _createBlock(PpTicketCheckResultsMainGameTable, {
                    key: 2,
                    lottery: _unref(config).lottery,
                    results: drawResults.boards
                  }, null, 8, ["lottery", "results"])),
            _cache[2] || (_cache[2] = _createElementVNode("p", { class: "pp-ticket-check-results-detail__text" }, "Uvedené informace jsou bez záruky.", -1)),
            isAddonPlayed
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                  _createElementVNode("h3", _hoisted_4, " Vaše uhodnutá čísla a výhry " + _toDisplayString(lotteryAddonDisplayName.value), 1),
                  _createVNode(PpTicketCheckResultsAddonTable, {
                    results: drawResults.addon
                  }, null, 8, ["results"]),
                  _cache[0] || (_cache[0] = _createElementVNode("p", { class: "pp-ticket-check-results-detail__text" }, "Uvedené informace jsou bez záruky.", -1))
                ], 64))
              : _createCommentVNode("", true),
            _cache[3] || (_cache[3] = _createElementVNode("h3", { class: "pp-ticket-check-results-detail__heading pp-ticket-check-results-detail__heading--with-top-floor" }, " Podrobné výsledky ", -1)),
            _createVNode(PpTicketCheckResultsDrawDetail, {
              lottery: _unref(config).lottery,
              "draw-id": drawResults.drawId
            }, null, 8, ["lottery", "draw-id"])
          ])
        ]))
      }), 128))
    ])
  ]))
}
}

})